import { FC, useContext, useEffect, useState } from "react";

import {
  Typography,
  Box,
  Grid,
  useMediaQuery,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Container,
  useTheme,
  Button,
  IconButton,
  withStyles,
  Theme,
  createStyles,
} from "@material-ui/core";
import useStyles from "../Styles/ShowProjectStyles";
import AdminHeader from "../SubComponents/AdminHeader";
import BackButton from "../../helpers/BackButton";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import EmptyWallets from "./EmptyWallets";
import Footer from "../SubComponents/Footer";
import { GetAllUserWallets } from "../../store/Wallet/WalletFunction";
import AddWalletDoalog from "./AddWalletDialog";
import { MdDelete } from "react-icons/md";
import ConfirmDeleteWallet from "./ConfirmDeleteWallet";
import DELETE_WALLET_MUTATION from "../../utils/mutations/wallet/deleteWallet";
import graphQLClient from "../../utils/authHeader";
import AlertContext from "../../store/Alert/AlertContext";
import { Colors } from "../../helpers/theme";

const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      padding: 0,
      opacity: 0.8,
      borderRadius: "15px",
      boxShadow: "none",
      transition: "background-color 0.3s ease, transform 0.3s ease",
      willChange: "transform",
      "&:nth-of-type(odd)": {
        backgroundColor: Colors.darkWhite,
      },
      "&:nth-of-type(even)": {
        backgroundColor: Colors.white,
      },
      "&:hover": {
        backgroundColor: Colors.secondaryWhite,
        cursor: "pointer",
        transform: "scale(1.02)",
      },
    },
  })
)(TableRow);

const Wallets: FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const [data, setData] = useState<any>([]);
  const { setAlert } = useContext<any>(AlertContext);
  const [isLoading, setIsLoading] = useState(true);
  const [openAddWallet, setOpenAddWallet] = useState(false);
  const [walletId, setWalletId] = useState<any>("");

  useEffect(() => {
    setIsLoading(true);
    const getWallets = async () => {
      const wallets = await GetAllUserWallets();
      if (wallets) {
        setIsLoading(false);
      }
      setData(wallets);
    };
    if (!openAddWallet) {
      getWallets();
    }
    return () => {
      setIsLoading(false);
    };
  }, [openAddWallet]);

  const handleDelete = (id: string) => {
    graphQLClient
      .request(DELETE_WALLET_MUTATION, { id })
      .then(() => {
        setAlert("Wallet deleted successfully", "success");
        setWalletId("");
        setData((data: any) => data.filter((wallet: any) => wallet.id !== id));
      })
      .catch(() => {
        setAlert("An error occurred while deleting wallet", "error");
      });
  };

  return (
    <>
      <AdminHeader />
      <Box
        className={classes.projectspages}
        mt={isActive ? 3 : 5}
        mb={5}
        component="section"
      >
        <Container fixed>
          <Grid container>
            <Grid xs={12}>
              <BackButton goBack />
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <Box
                display={"flex"}
                justifyContent="space-between"
                alignItems={"center"}
              >
                <ProjectPoolHeading title1="My" title2="Wallets" />
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.buyGainsButton}
                  onClick={() => setOpenAddWallet(true)}
                >
                  Add non-evm wallet
                </Button>
              </Box>
            </Grid>
            <Grid item md={12} sm={12} xs={12}>
              <>
                <Table className={classes.walletsHead}>
                  <TableBody>
                    <TableRow>
                      <TableCell align="center">
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className="fw-bold"
                        >
                          Blockchain
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className="fw-bold"
                        >
                          Address
                        </Typography>
                      </TableCell>
                      <TableCell align="center">
                        <Typography
                          component="span"
                          variant="subtitle1"
                          className="fw-bold"
                        >
                          Actions
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                <Table className={classes.firsttable}>
                  <TableBody>
                    <TableRow>
                      <TableCell
                        style={{
                          paddingLeft: "0",
                          paddingRight: "0",
                          paddingBottom: "0",
                        }}
                      >
                        {data?.length > 0 ? (
                          data.map((wallet: any) => (
                            <StyledTableRow
                              key={wallet.id}
                              className={classes.walletRow}
                            >
                              <TableCell align="center">
                                <Typography variant="subtitle1">
                                  {wallet.blockchain}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Typography variant="subtitle1">
                                  {isActive
                                    ? wallet.address.substr(0, 4) +
                                      "..." +
                                      wallet.address.substr(
                                        wallet.address.length - 4,
                                        wallet.address.length
                                      )
                                    : wallet.address}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <IconButton
                                  disabled={wallet.blockchain === "ETHEREUM"}
                                  onClick={() => setWalletId(wallet.id)}
                                >
                                  <MdDelete className="pointer" />
                                </IconButton>
                              </TableCell>
                            </StyledTableRow>
                          ))
                        ) : !isLoading ? (
                          <EmptyWallets />
                        ) : null}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Footer />
      <AddWalletDoalog open={openAddWallet} setOpen={setOpenAddWallet} />
      <ConfirmDeleteWallet
        open={Boolean(walletId)}
        setOpen={setWalletId}
        id={walletId}
        handleDelete={handleDelete}
      />
    </>
  );
};

export default Wallets;
